import { useStoreActions, useStoreState } from '~/store/hooks';
import extractFullName from '~/utils/text/extractFullName';
import { useApiRequest } from '~/hooks/api';

import AllocationTypes from '~/ui/pages/ActTeam/reusable/ClientAllocationForm/constants/allocationTypes';
import {
  IUseGetDuplicateAllocationResult,
  IUseGetEditClientAllocationsParams,
} from '~/ui/pages/ActTeam/reusable/ClientAllocationForm/EditClientAllocation/hooks/types';

const useGetDuplicateClientAllocationsForGlobalUser = ({
  clientAllocationDate,
  enabled = true,
}: IUseGetEditClientAllocationsParams): IUseGetDuplicateAllocationResult => {
  const {
    clinic: userClinic,
    id: userId,
    photo,
    ...user
  } = useStoreState(state => state.user.current);

  const { onGetOwnClientAllocationGU } = useStoreActions(actions => actions.clientAllocation);
  const clientAllocations = useStoreState(state => state.clientAllocation.current) || [];

  const userFullName = extractFullName(user);

  const { isLoading, refetch } = useApiRequest(
    async () => {
      const allocationDate = `${clientAllocationDate}T00:00:00Z`;

      await onGetOwnClientAllocationGU({
        clientAllocationDate: allocationDate,
        allocationType: AllocationTypes.ALL,
      });
    },
    {
      enabled,
      dependencies: [clientAllocationDate, userClinic.id, userId, userFullName, photo],
    },
  );

  return {
    isLoading,
    allocations: clientAllocations,
    refetch,
  };
};

export default useGetDuplicateClientAllocationsForGlobalUser;
